import { MetricCardType } from "@/components/MetricCard/MetricCard.types";
import { Path } from "@/router";

export const PAT_ACTIVITY_SCROLL_ID = "pat-activity-table";
export const QUALIFYING_LEVEL_REQUIREMENTS_SCROLL_ID = "qualifying-requirements-table";

const MEMBERSHIP_PROGRESS_SCROLL_IDS = [PAT_ACTIVITY_SCROLL_ID, QUALIFYING_LEVEL_REQUIREMENTS_SCROLL_ID] as const;

export type MembershipProgressScrollTarget = (typeof MEMBERSHIP_PROGRESS_SCROLL_IDS)[number];

export type MembershipProgressLinkOptions = {
  qualifyingLevelSectionEnabled?: boolean;
  scrollTo?: MembershipProgressScrollTarget;
  navigate?: (to: string) => void;
};

export function isMembershipProgressScrollTarget(value: string): value is MembershipProgressScrollTarget {
  return (MEMBERSHIP_PROGRESS_SCROLL_IDS as readonly string[]).includes(value);
}

export type MembershipProgressPath =
  | "/people/:pgaId/membership/path-to-membership"
  | "/people/:pgaId/membership/prospect-program";

export function membershipProgressPath(qualifyingLevelSectionEnabled = false): MembershipProgressPath {
  return qualifyingLevelSectionEnabled
    ? "/people/:pgaId/membership/path-to-membership"
    : "/people/:pgaId/membership/prospect-program";
}

export function membershipProgressHref(pgaId: string, options: MembershipProgressLinkOptions): string {
  const tab = options.qualifyingLevelSectionEnabled ? "path-to-membership" : "prospect-program";
  const path = `/people/${pgaId}/membership/${tab}`;

  if (!options.scrollTo) return path;
  if (!options.qualifyingLevelSectionEnabled && options.scrollTo === QUALIFYING_LEVEL_REQUIREMENTS_SCROLL_ID) {
    return path;
  }

  return `${path}?scrollTo=${options.scrollTo}`;
}

export function membershipProgressCardNavigation(
  pgaId: string | undefined,
  options: MembershipProgressLinkOptions
): Pick<MetricCardType<Path>, "link" | "onClick"> {
  if (!pgaId) return {};

  const href = membershipProgressHref(pgaId, options);
  if (href.includes("?")) {
    return { onClick: () => options.navigate?.(href) };
  }

  return {
    link: {
      to: membershipProgressPath(options.qualifyingLevelSectionEnabled),
      params: { pgaId }
    }
  };
}
